
import { AngularFirestore } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { switchMap, first, take } from "rxjs/operators";
import * as firebase from 'firebase/app';

import { TaskService } from '@app/core/services/task.service';

import * as moment from 'moment-timezone';

import * as geofirex from 'geofirex';
import { FooterComponent } from '@app/shared/layout';
import { homeRoutes } from '../home/home.routing';
const geo = geofirex.init(firebase);

export interface User{
  [key: string]: any;
}




@Injectable()
export class ShopsDAO {

  private ref: string = "shops";

  timezone = "America/Guayaquil";
  
  constructor(private afs: AngularFirestore,
      private taskService: TaskService) { 
    
  }

  /**
   * Almacena en la bd el comercio y las sucursales como una nueva colección, agregando la referencias en 
   * el documento Shops
   * @param shops 
   * @param collection 
   */
  async save(shops: any, collection: string) {    
    let array = shops[collection];
    try {

      if(array){
        for(let item of array){

          console.log("schuel", item, item.schedule);
          if(item.schedule===undefined){
            item.schedule = [
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
              {hours: [{to: '', from: ''}, {to: '', from: ''}]},
            ];
          }
        }
      }

      await this.afs.collection(this.ref).doc(shops.uid).set(Object.assign({}, shops), { merge: true });
      if(array){
        for(let item of array){
          const users:{[k: string]: any} = {};
          
          if(shops.users){
            for(let user of shops.users){
              for(let office of user.offices){
                if(office.uid == item.uid){
                  let aux = user.uid;
                  users[aux] = true;
                }
              }
            }
          }
          
          item.location = new firebase.firestore.GeoPoint(item.lat, item.lng);
          const point = geo.point(item.lat, item.lng);
          item.point = point.data;
          const office = { ...item, shop: {uid: shops.uid, name: shops.shop_name, 
            type:shops.type, images:shops.images, logos:shops.logos, description:shops.description}, users};
          await this.afs.collection(collection).doc(item.uid).set(office, { merge: true });

          await this.programSchedule(office);
        }
      }
      return true;
    } catch (err) {
      console.error("Error save shop", err);
      throw err;
    }
  }
  
  /*searchUser(email: string){
    try{
        return this.afs.collection("admins", ref => ref.where('email', '==', email).where('delete', '==', false));
    }catch(error){
      console.error("Error searchUser", error);
      throw error;
    }
  }*/

  public programSchedule(office:any){

    console.log(office);

    let data = this.getNextDay(office);
    console.log('dia', data);

    if(data!==null){
      console.log(data);
      const time = firebase.firestore.Timestamp.now().toDate();
      var now = moment.tz(time, this.timezone);
      //console.log(now);
      let day = now.format('YYYY-MM-DD') + ' ' + data.hour;
      let date = moment.tz(day, 'YYYY-MM-DD HH:mm', this.timezone).add(data.day, 'days');
      console.log("=> " + data.open?'Abrir':'Cerrar', date.toDate());

      let timestamp:number = date.utc().toDate().getTime();
      //console.log("timestamp", timestamp);

      this.taskService.updateTaskAt(
        office.uid,
        timestamp,  
        'scheduledOfficeOpen',
        { office:office.uid, date:moment.tz(date, this.timezone).format(), ...data});
    }

    

    //let time:number = new Date(dateOrder).getTime()-(notificationTime*60*1000);

    /*this.taskService.performAt(
      time,  
      'scheduledOrder',
      data);*/
  }

  private getNextDay(office:any){
    let data:any = {
      day:-1,
      open:true,
      hour:null
    };
    const time = firebase.firestore.Timestamp.now().toDate();

  

    //console.log("utc", moment(time).utc().format());

    

    //let day = moment(now).format('YYYY-MM-DD HH:mm');

    //let d = moment(now);

    var now = moment.tz(time, this.timezone);
    //var madrid = d.clone().tz("Europe/Madrid");

    //console.log("day", d);
    //console.log("gye", now.format());
    //console.log("madrid", madrid);

    //let idx = moment(now).day();//.format('YYYY-MM-DD');
    let idx = now.day();//.format('YYYY-MM-DD');
    console.log("dia", idx);
    idx = idx==0?6:idx-1;
   
    var programed = false;

    //console.log(moment(now).hours, moment(now).minutes);
    
    //let aux = moment(now).format('HH:mm');

    let select = office.schedule[idx];
    //console.log("idx", idx);
    //console.log("day", day);
    //console.log("aux", aux);

    console.log("select", select);
    let i=-1;
    for(let hour of select.hours){
      var from = moment(hour.from, 'HH:mm');
      var to = moment(hour.to, 'HH:mm');
      var date = moment.tz(time, 'HH:mm', this.timezone);

      console.log("fechas", from.format(), to.format(), date.format());

      if(date.isBetween(from,to)){
        console.log("**dentro toca cerrar a las " + hour.to );
        return data = {day:0, open:false, hour:hour.to};
      }else if(date.isBefore(from)){
        console.log("**dentro toca abrir a las " + hour.from );
        return data = {day:0, open:true, hour:hour.from};
      }
    }

    if(programed==false){
      for(i=idx+1; i<=6; i++){
        let select = office.schedule[i];
        console.log("horario " + i , select);
        for(let hour of select.hours){
          if(hour.from!==''){
            console.log("++ toca abrir (" + i + ") a las " + hour.from );
            return data = {day:i-idx, open:true, hour:hour.from};
          }else if(hour.to!==''){
            console.log("++ toca cerrar (" + i + ") a las " + hour.to );
            return data = {day:i-idx, open:false, hour:hour.to};
          }
        }
      }
    }

    if(programed==false){
      for(let j=0; j<=idx; j++){
        let select = office.schedule[j];
        console.log("horario vuelta " + j, select);
        for(let hour of select.hours){
          if(hour.from!==''){
            console.log("-- toca abrir (" + i + ") a las " + hour.from );
            return data = {day:i+j-idx, open:true, hour:hour.from};
          }else if(hour.to!==''){
            console.log("-- toca cerrar (" + i + ") a las " + hour.to );
            return data = {day:i+j-idx, open:false, hour:hour.to};
          }
        }
      }
    }

    return null;
  }

  async searchUserByEmail(email: string){
    try{
        let aux = await this.afs.collection("admins", 
            ref => ref.where('email', '==', email)
                      .where('delete', '==', false))
                      .valueChanges().pipe(first()).toPromise().then(doc => {
                          return doc;
                      }).catch(error => {
                          throw error;
                      });
        if(aux.length==0)
            return {displayName: '', email: email, rol: null};
        return aux[0];
    }catch(error){
      console.error("Error searchUserByEmail", error);
      throw error;
    }
    
  }
}
